export * from './FeaturesBlock';

import { FeaturesBlock } from './FeaturesBlock';

export default FeaturesBlock;
